var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Tooltip } from '@hn-ui/tooltips';
import { Container, Cell } from '../Common';
import { RecoverButton } from '../../Buttons';
var MAX_NAME_LENGTH = 35;
var DeletedContainer = styled(Container).withConfig({ displayName: "DeletedContainer", componentId: "sc-1xc1e3h" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  grid-template-columns: 400px 76px;\n  justify-content: space-between;\n"], ["\n  grid-template-columns: 400px 76px;\n  justify-content: space-between;\n"])));
var DeletedStudentRow = function (_a) {
    var id = _a.id, name = _a.name, onRecover = _a.onRecover;
    var handleOnRecover = function () {
        onRecover(id);
    };
    return (_jsxs(DeletedContainer, { children: [_jsx(Cell, { children: name.length > MAX_NAME_LENGTH ? (_jsx(Tooltip, __assign({ content: name, maxWidth: 320 }, { children: _jsxs("span", { children: [name.substring(0, MAX_NAME_LENGTH), "..."] }, void 0) }), void 0)) : (name) }, void 0), _jsx(Cell, { children: _jsx(RecoverButton, { onClick: handleOnRecover }, void 0) }, void 0)] }, void 0));
};
export { DeletedStudentRow };
var templateObject_1;
